import { DiscountDto, UpdateDiscountOutDto, NewDiscountOutDto } from "../../types";
import {
  NEW_DISCOUNT,
  NewDiscount,
  ResetNewDiscount,
  RESET_NEW_DISCOUNT,
} from "../types/discount/new-discount";

import {
  UPDATE_DISCOUNT,
  UpdateDiscount,
  ResetUpdateDiscount,
  RESET_UPDATE_DISCOUNT,
} from "../types/discount/update-discount";

import {
  DELETE_DISCOUNT,
  DeleteDiscount,
  RESET_DELETE_DISCOUNT,
  ResetDeleteDiscount,
} from "../types/discount/delete-discount";

import {
  SELECTED_DISCOUNT,
  SelectedDiscount,
} from "../types/discount/selected-discount";
import {
  GetAllDiscounts,
  GET_ALL_DISCOUNTS,
} from "../types/discount/all-discounts";

import { GetOneDiscount, GET_ONE_DISCOUNT } from "../types/discount/get-one-discount";
import { ExistDiscount, EXIST_DISCOUNT, ResetExistDiscount, RESET_EXIST_DISCOUNT } from "../types/discount/exist-discount";

export const newDiscount = (payload: NewDiscountOutDto): NewDiscount => {
  return { type: NEW_DISCOUNT, payload };
};

export const resetNewDiscount = (): ResetNewDiscount => {
  return { type: RESET_NEW_DISCOUNT, payload: undefined };
};

export const updateDiscount = (payload: UpdateDiscountOutDto): UpdateDiscount => {
  return { type: UPDATE_DISCOUNT, payload };
};

export const resetUpdateDiscount = (): ResetUpdateDiscount => {
  return { type: RESET_UPDATE_DISCOUNT, payload: undefined };
};


export const deleteDiscount = (payload: { id: number }): DeleteDiscount => {
  return { type: DELETE_DISCOUNT, payload };
};

export const resetDeleteDiscount = (): ResetDeleteDiscount => {
  return { type: RESET_DELETE_DISCOUNT, payload: undefined };
};


export const getAllDiscounts = (payload: { plan_id?: number, show_in_page: boolean }): GetAllDiscounts => {
  return { type: GET_ALL_DISCOUNTS, payload };
};


export const getDiscount = (payload: { id: number }): GetOneDiscount => {
  return { type: GET_ONE_DISCOUNT, payload };
};


export const existDiscount = (payload: { coupon_id: number }): ExistDiscount => {
  return { type: EXIST_DISCOUNT, payload };
};

export const resetExistDiscount = (): ResetExistDiscount => {
  return { type: RESET_EXIST_DISCOUNT, payload: undefined };
};

export const selectedDiscount = (payload: DiscountDto): SelectedDiscount => {
  return { type: SELECTED_DISCOUNT, payload };
};

